import React, { useState, useEffect } from "react";
import Support from "./Support";
import "./Home.css";


const slides = [
  {
    id: 1,
    title: "Solar",
    desc: "CPU Core i7-4790 | 8GB RAM | 512GB NVMe SSD | HDMI | VGA |1Gbps LAN | USB 3.0 | HD Graphics | Windows 11 + MS Office (Home PC i7 CPU,SSD_512GB_8GB_RAM/Solar",
    image: "https://m.media-amazon.com/images/I/51bXa1jE4NL._SX679_.jpg",
  },
  {
    id: 2,
    title: "Vault X4",
    desc: "CPU Desktop PC Core i7-4770, GPU Quadro K2200 4GB+16GB RAM,1TB SSD,HDMI,VGA,1GBs LAN,USB 3.0+Windows 11 License | Trading&Editing (Graphics Card Quadro K2200, 1TB NVMe SSD,16GB Vaultx4).",
    image: "https://m.media-amazon.com/images/I/51Nf8VqFoGL._SX679_.jpg",
  },
  {
    id: 3,
    title: "Valult X3",
    desc: "Desktop PC || CPU i7-4790 Turbo || 16GB RAM || GT730 4GB GPU || 1TB SSD NVMe|| HDMI,VGA,Giga LAN,USB 3.0+Windows 11 License,MS Office(VX3-i7/16GBRAM/GT730/1TB)",
    image: "https://m.media-amazon.com/images/I/51bThssmgTL._SX679_.jpg",
  },
  {
    id: 4,
    title: "Gaming PC",
    desc: "Gaming Desktop PC, Core i7-12700K 12thGEN CP, Liquid Cooler CPU Display, 32GB DDR5 RAM, 1TB NVMe SSD, GTX1660 6GB DDR6 GPU, 5G WiFi&BT, Win11 Pro(Eclipse-i7/32GRAM/1TB/D6GPU6)",
    image: "https://m.media-amazon.com/images/I/41FSyRlT66L._SY300_SX300_QL70_FMwebp_.jpg",
  },
];

export default function Home({ showSupport = false }) {
  const [current, setCurrent] = useState(0);

  const nextSlide = () => setCurrent((prev) => (prev + 1) % slides.length);  //3+1 = 4%4 = 0 first step 
  const prevSlide = () => setCurrent((prev) => (prev - 1 + slides.length) % slides.length); //0-1 = -1+4 = 3%4 = 3 

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <>
    <div className="hero-slider">
      <button className="home-arrow left" onClick={prevSlide}>‹</button>

      <div className="slides">
        {slides.map((slide, index) => {
          let position = "nextSlide";
          if (index === current) position = "activeSlide";
          if (index === (current - 1 + slides.length) % slides.length)
            position = "lastSlide";

          const isEven = index % 2 === 0; // alternate sides

          return (
            <div className={`slide ${position}`} key={slide.id}>
              {isEven ? (
                <>
                  <div className="slide-content">
                    <h2>{slide.title}</h2>
                    <p>{slide.desc}</p>
                    {/* <button>Shop Now</button> */}
                  </div>
                  <img src={slide.image} alt={slide.title} />
                </>
              ) : (
                <>
                  <img src={slide.image} alt={slide.title} />
                  <div className="slide-content">
                    <h2>{slide.title}</h2>
                    <p>{slide.desc}</p>
                    {/* <button>Shop Now</button> */}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>

      <button className="home-arrow right" onClick={nextSlide}>›</button>

      <div className="dots">
        {slides.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === current ? "active" : ""}`}
            onClick={() => setCurrent(i)}
          ></span>
        ))}
      </div>
      
    </div>
   <div className="support-container">
    <Support/>
    </div>
    </>
  );
}
